import { cva } from "class-variance-authority";

export const buttonVariants = cva(
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
    {
        variants: {
            variant: {
                default:
                    "border-orange-200 border text-rose-500 bg-orange-100/50 hover:bg-orange-100/90 rounded-tl-3xl rounded-br-3xl",
                internal:
                    "bg-blue-300 text-blue-900 hover:bg-blue-400 border-blue-900 border  rounded-tl-3xl rounded-br-3xl",
                circle: "border-orange-200 border text-rose-500 hover:bg-orange-100/90 rounded-full border-orange-100",
                subtle: "border-orange-200 border text-rose-500 hover:bg-orange-100/90 rounded-tl-3xl rounded-br-3xl",
                destructive:
                    "border border-rose-500 bg-background text-rose-500 hover:bg-accent hover:text-accent-foreground",
                outline:
                    "border border-input bg-background border-rose-100 text-rose-500 hover:bg-orange-100/90 hover:text-rose-500",
                secondary:
                    "bg-secondary text-secondary-foreground hover:bg-secondary/80",
                ghost: "hover:bg-orange-100/90 hover:text-rose-500 text-rose-500 rounded-tl-3xl rounded-br-3xl",
                link: "text-rose-900 underline underline-offset-4 hover:text-rose-700",
                ghostIcon:
                    "hover:bg-orange-100/90 hover:text-rose-500 text-rose-500",
                actionIcon:
                    "bg-orange-100/50 text-rose-500 border border-orange-100 hover:bg-orange-100",
            },
            size: {
                default: "h-10 px-4 py-2",
                sm: "h-9 rounded-md px-3",
                lg: "h-11 rounded-md px-8",
                icon: "h-10 w-10",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    },
);
